import {
  Input as AntdInput,
  InputProps as AntdInputProps,
  Typography,
} from "antd";
import React from "react";

const InputPassword: React.FC<AntdInputProps & { label?: string }> = (
  props,
  label
) => {
  return (
    <div>
      {label ? (
        <label htmlFor="accessible-antd-password-input">
          <Typography.Text strong>{props.label}</Typography.Text>
        </label>
      ) : null}
      <AntdInput.Password
        id="accessible-antd-password-input"
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeholder}
        aria-labelledby="accessible-antd-password-input"
        aria-describedby="accessible-antd-input-password-help"
        aria-required={props.required}
        {...props}
      />
    </div>
  );
};

export default InputPassword;
